import { Typography, TextField } from "@mui/material";
import React from "react";
import { Control } from "react-hook-form";

import CustomTextField from "../../../../../../../../components/molecules/custom-textfield/custom-textfield";
import { DocumentIcon } from "./HeaderIcons";

type FormData = {
    document_title: string;
    enterprise: string;
    project: string;
};

interface IHeaderTitleProps {
    control: Control<FormData, any>;
    title: string;
    isEditing: boolean;
}

export default function HeaderTitle({
    control,
    title,
    isEditing,
}: IHeaderTitleProps) {
    return (
        <>
            {isEditing ? (
                <CustomTextField
                    fullWidth
                    control={control}
                    name="document_title"
                    variant="outlined"
                    label="Título do documento"
                    InputProps={{
                        startAdornment: <DocumentIcon />,
                    }}
                    sx={{ mb: 2 }}
                />
            ) : (
                <Typography
                    variant="h5"
                    sx={{ display: "flex", alignItems: "center", gap: 1 }}
                >
                    <DocumentIcon />
                    {title || "DPP - Documento de Proposição de Projeto"}
                </Typography>
            )}
        </>
    );
}
